
<h2 mat-dialog-title style="margin:0 0 8px 0;">Notification</h2>
<div mat-dialog-content style="font-size: 14px; color: #1f2937;">
  {{ message }}
</div>
<div mat-dialog-actions align="end" style="gap: 8px; margin-top: 6px;">
  <button mat-stroked-button color="primary" [mat-dialog-close]="true">OK</button>
</div>
